import React from "react";
import {
  Button as MUIButton,
  ButtonProps,
  createMuiTheme,
} from "@material-ui/core";
import { ThemeProvider } from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "../../containers/Visualizer/Loader";

const useStyles = makeStyles({
  label: {
    color: "#C41230",
    fontWeight: 600,
    fontSize: "13px",
    fontFamily: "'Montserrat', sans-serif",
  },
  text: {
    "& 	.MuiButton-label": {
      color: "rgba(0,0,0,0.6)",
    },
  },
  outlinedSecondary: {
    boxSizing: "border-box",
    border: "2px solid #C41230",
  },
});

function Button({ reverse, label, Icon, loading, ...rest }: IButton) {
  const classes = useStyles();

  return (
    <MUIButton
      style={{ borderRadius: 0, height: "45px", width: "100%" }}
      variant="contained"
      color="primary"
      disableElevation
      classes={{
        label: classes.label,
        outlinedSecondary: classes.outlinedSecondary,
        text: classes.text,
      }}
      {...rest}
    >
      {reverse ? (
        <>
          {" "}
          {Icon && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: reverse ? "0px 8px 0px 0px" : "0px 0px 0px 15px",
              }}
            >
              {Icon}
            </div>
          )}
          {loading? <Loader/>:label}
        </>
      ) : (
        <>
          {loading? <Loader/>:label}{" "}
          {Icon && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "15px",
              }}
            >
              {Icon}
            </div>
          )}
        </>
      )}
    </MUIButton>
  );
}

export interface IButton extends ButtonProps {
  label: string;
  Icon?: React.ReactNode;
  reverse?: boolean;
  loading?:boolean
}

export default Button;
